import { render, staticRenderFns } from "./CategoryLists.vue?vue&type=template&id=2df16cf4"
import script from "./CategoryLists.vue?vue&type=script&lang=js"
export * from "./CategoryLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports